

@if(routeItem()){
    <map-marker 
        [position]="routeItem().currentLocation"
        [options]="getItemOptions(routeItem())" 
    />

    @for(item of routeItem()?.relatedsItems; track item.id; let i = $index) {
        {{ item | json }}
        <map-marker 
            (mapClick)="handleRecommendedMarkerClick(item)" 
            [position]="item.currentLocation"
            [options]="recommendedMarkerOption(i + 1)" 
        />
    }
}

@if(detailsItem()){
    <map-marker 
        [position]="detailsItem().location"
        [options]="recommendedMarkerOption()" 
    />
}
